jQuery( document ).ready(function($) {
  if($('.landing').length > 0) {
    console.log('test');
    $('.instagram').hide()

    $('.formulaire_button').click(function(){
      console.log('submit');
        var valid = this.form.checkValidity();
        var lname = $("#lname").val();
        var fname = $("#fname").val();
        var postcode = $("#postcode").val();
        var city = $("#city").val();
        var email = $("#email").val();

        if(lname == "") {
          $('#lname_alert').css('visibility', 'visible');
        }
        else {
          $('#lname_alert').css('visibility', 'hidden');
        }
        if(fname == "") {
          $('#fname_alert').css('visibility', 'visible');
        }
        else {
          $('#fname_alert').css('visibility', 'hidden');
        }
        var testPostcode = /^\d{4,5}$/;
        if(postcode == "") {
          $('#postcode_alert').css('visibility', 'visible');
        }
        else if (testPostcode.test(postcode) == false) {
          $('#postcode_alert').text("Format numérique requis : XXXXX");
          $('#postcode_alert').css('visibility', 'visible');
        }
        else {
          $('#postcode_alert').css('visibility', 'hidden');
        }
        if(city == "") {
          $('#city_alert').css('visibility', 'visible');
        }
        else {
          $('#city_alert').css('visibility', 'hidden');
        }
        var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
        if(email == "") {
          $('#email_alert').css('visibility', 'visible');
        } else if (testEmail.test(email) == false) {
          $('#email_alert').text("L'adresse mail saisie est non valide !");
          $('#email_alert').css('visibility', 'visible');
        }
        else {
          $('#email_alert').css('visibility', 'hidden');
        }
        if($("#rules").prop("checked") == false){
          $('#rules_alert').css('visibility', 'visible');
        }
        else {
          $('#rules_alert').css('visibility', 'hidden');
        }
        if (valid) {

          event.preventDefault();
          var lname = $("#lname").val();
          var fname = $("#fname").val();
          var postcode = $("#postcode").val();
          var city = $("#city").val();
          var email = $("#email").val();
          jQuery.post(
              my_ajax_object.ajax_url,
              {
                'action': 'register_competition',
                'lname': lname,
                'fname': fname,
                'postcode': postcode,
                'city': city,
                'email': email
              },
              function(response){
                  if(response == 'fail') {
                    $('.overlay').css('visibility', 'visible');
                    $('.overlay_fail').css('visibility', 'visible');
                    $('.overlay_fail').css('display', 'block');
                    console.log('fail');
                  }else {
                    console.log(response);
                    $('.overlay_success_link').attr("href", response);
                    $('.overlay').css('visibility', 'visible');
                    $('.overlay_success').css('visibility', 'visible');
                    $('.overlay_success').css('display', 'block');
                    // window.location.href=response;
                  }
              }
          );
        }
    });
    $('.overlay').click(function(){
      $('.overlay').css('visibility', 'hidden');
      $('.overlay_success').css('visibility', 'hidden');
      $('.overlay_fail').css('visibility', 'hidden');
      $('.overlay_success').css('display', 'none');
      $('.overlay_fail').css('display', 'none');
    });
    $('.overlay_fail').click(function(){
      window.location.href='/';
    });
    $('.overlay_success').click(function(){
      window.location.href='/';
    });

    // End Landing Page for Competition
    
  }
});
